<div
    *ngIf="isQuotaExceeded"
    class="agpr-quotaExceededBanner"
>
    <agpr-message
        [id]="id"
        [severity]="messageSeverityEnum.error"
        [toggleable]="true"
        [collapsed]="true"
        [toggleableContent]="bannerMessage"
        [style]="agprComponentStyleEnum.social"
    >
        <p>  {{ 'Social.quotaExceededBanner.heading' | localize }} </p>
        <ng-template #bannerMessage>
            <div class="agpr-quotaExceededBanner-messageContainer">
                <p>
                    {{ 'Social.quotaExceededBanner.messageOne' | localize }}
                <agpr-button
                    class="agpr-quotaExceededBanner-link"
                    [style]="buttonTypes.link"
                    (click)="openQuotaInformationPanel()"
                >
                    {{ 'Social.quotaExceededBanner.messageLink' | localize}}
                </agpr-button>
                    {{ 'Social.quotaExceededBanner.messageTwo' | localize}}
                </p>
            </div>
        </ng-template>
    </agpr-message>
</div>